function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { system } from "styled-system";
import { transformGridValue } from "./transforms";
var gridPaddingConfig = {
  property: "padding",
  scale: "space",
  transform: function transform(value, scale) {
    return transformGridValue(value, scale);
  }
};
var paddingConfig = {
  property: "padding",
  scale: "space"
};

var paddingTop = _extends({}, paddingConfig, {
  property: "paddingTop"
});

var paddingBottom = _extends({}, paddingConfig, {
  property: "paddingBottom"
});

var paddingY = _extends({}, paddingConfig, {
  property: undefined,
  properties: ["paddingTop", "paddingBottom"]
});

var paddingRight = _extends({}, gridPaddingConfig, {
  property: "paddingRight"
});

var paddingLeft = _extends({}, gridPaddingConfig, {
  property: "paddingLeft"
});

var paddingX = _extends({}, gridPaddingConfig, {
  property: undefined,
  properties: ["paddingLeft", "paddingRight"]
});

export var padding = system({
  // dynamic grid units
  paddingRight: paddingRight,
  pr: paddingRight,
  paddingLeft: paddingLeft,
  pl: paddingLeft,
  paddingX: paddingX,
  px: paddingX,
  // normal units
  padding: paddingConfig,
  p: paddingConfig,
  paddingTop: paddingTop,
  pt: paddingTop,
  paddingBottom: paddingBottom,
  pb: paddingBottom,
  paddingY: paddingY,
  py: paddingY
});
export default padding;